const GRAPHQL_API_URL = process.env.NEXT_PUBLIC_GRAPHQL_API_URL
const PUBLIC_API_URL = process.env.NEXT_PUBLIC_API_URL
const NEXT_PUBLIC_VERCEL_URL = process.env.NEXT_PUBLIC_VERCEL_URL

if (!GRAPHQL_API_URL) {
    throw new Error('Environment variable NEXT_PUBLIC_GRAPHQL_API_URL is missing.')
}

if (!PUBLIC_API_URL) {
    throw new Error('Environment variable NEXT_PUBLIC_API_URL is missing.')
}

export const config = {
    graphqlApiUrl: GRAPHQL_API_URL,
    publicApiUrl: PUBLIC_API_URL,
    publicVercelApiUrl: NEXT_PUBLIC_VERCEL_URL,
}
